<template>
  <section class="webzine-list-wrapper">
    <section class="loading text-center pt-5" v-show="list.length == 0">
      <i class="my-3 mx-2 icon icon-loading icon-56"></i>
      <i class="my-3 mx-2 icon icon-loading icon-56"></i>
      <i class="my-3 mx-2 icon icon-loading icon-56"></i>
    </section>
    <b-row class="webzine-all">
      <b-col
        class="webzine-el"
        cols="12"
        md="4"
        v-for="(webzine, i) in list"
        :key="i"
        @click="$router.push('/webzine/' + webzine._id)"
      >
        <div class="py-4">
          <figure class="position-relative">
            <img
              :src="webzine.thumbnail"
              class="position-absolute top-0 left-0 zIndex-10"
              :alt="webzine.title"
            />
            <div
              class="position-absolute w-100 h-100 top-0 left-0 bg-secondary"
            ></div>
          </figure>
          <figcaption class="px-2 p-md-2">
            <h4 class="text-16 text-lg-18 mb-1 text-grey-dark text-truncate">
              <!-- <strong
                :class="'text-' + webzine.color"
                class="d-block mb-2 mb-md-0 d-md-inline"
              >
                {{ webzine.category }}을 담다
              </strong> -->
              {{ webzine.title }}
            </h4>
          </figcaption>
        </div>
      </b-col>
    </b-row>
  </section>
</template>

<script>
export default {
  props: {
    list: Array
  },
  mounted() {
    // 로딩애니메이션
    this.$store.commit("loadingAnime");
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/colors.scss";

// webzines
.webzine-el {
  figure {
    height: 18rem;
    overflow: hidden;
    background-size: cover !important;
    background-repeat: no-repeat;
    background-position: center center;
    img {
      width: 100% !important;
      height: 100% !important;
      object-fit: cover !important;
      @media all and (max-width: 768px) {
        transform: translate(8px, 8px);
      }
    }
    &:hover {
      cursor: pointer;
      img {
        transition: 0.2s;
        transform: translate(16px, 16px);
        transition-timing-function: ease-in-out;
      }
    }
  }
}
</style>
